import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { getNameWithFilter, setHash } from '../../../../../utils/help';
import { ThemeContext } from '../../../../App/ThemeContext';
import { NavigationContext as Context } from '../../../Context';
import { ReactComponent as Arrow } from '../../../../../assets/imgs/svg/arrow.svg';
import { ReactComponent as Check } from '../../../../../assets/imgs/svg/check.svg';
import { ReactComponent as Test } from '../../../../../assets/imgs/svg/test.svg';
import { ReactComponent as Ask } from '../../../../../assets/imgs/svg/ask.svg';
import { ReactComponent as Revision } from '../../../../../assets/imgs/svg/revision.svg';
import commonClasses from '../../NavComponents.module.scss';
import classes from './Act.module.scss';

const behaivorSvg = (behavior) => {
  switch (behavior) {
    case 'ask': return <Ask className={classes.behavior} />;
    case 'check': return <Check className={classes.behavior} />;
    case 'test': return <Test className={classes.behavior} />;
    case 'revision': return <Revision className={classes.behavior} />;
    default: return <Ask className={classes.behavior} />;
  }
};

const Act = (props) => {
  const { act, actIndex, topicIndex } = props;
  const context = useContext(Context);
  const { theme } = useContext(ThemeContext);
  const {
    selected,
    modules,
    filter,
    order,
    completeIcon,
  } = context;

  let result = null;

  if (act.show) {
    result = (
      <div key={actIndex} className={`${classes.Act} ${theme ? classes[theme] : ''} ${selected.act === actIndex ? classes.open : ''}`}>
        <div
          role="button"
          className={`${commonClasses.Label} ${classes.label} ${act.revision === 'revision' ? classes.Revision : ''}`}
          onClick={() => context.onActClick(actIndex)}
          onKeyDown={(event) => { if (event.key === 'Enter') context.onActClick(actIndex); }}
          tabIndex={selected.topic === topicIndex ? '0' : '-4'}
        >
          <span className={classes.title}>
            { ReactHtmlParser(getNameWithFilter(act.name, filter)) }
          </span>
          <Arrow className={`${commonClasses.LabelArrow} ${classes.LabelArrow}`} />
        </div>
        <div className={`${commonClasses.dropDownBlock} ${selected.act === actIndex ? commonClasses.open : ''}`}>
          {act.children.map((content) => {
            let contentResult = null;
            if (content.show) {
              const curIndex = modules.findIndex((module) => module.id.toString() === content.id.toString());
              if (order === 'true' && curIndex !== 0 && modules[curIndex - 1].opened === 'false') {
                contentResult = (
                  <div
                    // id={content.id}
                    key={content.id}
                    className={`${classes.Content} ${classes.Closed}`}
                  >
                    {behaivorSvg(content.behavior)}
                    <span className={classes.title}>
                      {ReactHtmlParser(getNameWithFilter(content.name, filter))}
                    </span>
                  </div>
                );
              } else {
                contentResult = (
                  <div
                    role="button"
                    id={content.id}
                    key={content.id}
                    data-navigation-id={content.code}
                    className={`${classes.Content} ${selected.content.toString() === content.id.toString() ? classes.selected : ''}`}
                    onClick={() => { setHash(content.id); }}
                    onKeyDown={(event) => { if (event.key === 'Enter') { setHash(content.id); } }}
                    tabIndex={selected.act === actIndex ? '0' : '-4'}
                  >
                    {behaivorSvg(content.behavior)}
                    <span className={classes.title}>
                      {ReactHtmlParser(getNameWithFilter(content.name, filter))}
                    </span>
                    {(completeIcon === 'true'
                      && content.opened === 'true'
                      && content.finished === 'false')
                      && <div className={classes.opened} />}
                    {(completeIcon === 'true'
                      && content.finished === 'true')
                      && <div className={classes.finished} />}
                  </div>
                );
              }
            }
            return contentResult;
          })}
        </div>
      </div>
    );
  }

  return result;
};

export default React.memo(Act);

Act.propTypes = {
  act: PropTypes.shape({
    name: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  actIndex: PropTypes.number.isRequired,
  topicIndex: PropTypes.number.isRequired,
  completeIcon: PropTypes.string,
};

Act.defaultProps = {
  completeIcon: 'false',
};
